(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- scroll reveal ---- */
  function reveal() {
    var els = document.querySelectorAll('[data-reveal]:not(.is-in)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(els, function (e) { e.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.06 });
    Array.prototype.forEach.call(els, function (e) { io.observe(e); });
  }
  reveal();

  /* ---- header hide / stick ---- */
  var head = document.querySelector('[data-header]');
  if (head) {
    var last = 0, tick = false;
    window.addEventListener('scroll', function () {
      if (tick) return; tick = true;
      window.requestAnimationFrame(function () {
        var y = window.pageYOffset || document.documentElement.scrollTop;
        head.classList.toggle('is-stuck', y > 20);
        head.classList.toggle('is-hidden', y > 260 && y > last + 4);
        last = y; tick = false;
      });
    }, { passive: true });
  }

  /* ---- announcement close ---- */
  var ann = document.querySelector('[data-ann]');
  var annClose = document.querySelector('[data-ann-close]');
  if (ann && annClose) {
    try { if (sessionStorage.getItem('vx-ann') === 'off') ann.classList.add('is-off'); } catch (e) {}
    annClose.addEventListener('click', function () {
      ann.classList.add('is-off');
      try { sessionStorage.setItem('vx-ann', 'off'); } catch (e) {}
    });
  }

  /* ---- drawer ---- */
  var drawer = document.querySelector('[data-drawer]');
  function openDrawer() { if (drawer) { drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; } }
  function closeDrawer() { if (drawer) { drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; } }
  document.addEventListener('click', function (ev) {
    if (ev.target.closest('[data-open-drawer]')) { ev.preventDefault(); openDrawer(); }
    if (ev.target.closest('[data-drawer-close]')) { ev.preventDefault(); closeDrawer(); }
  });
  document.addEventListener('keydown', function (ev) { if (ev.key === 'Escape') closeDrawer(); });

  /* ---- product gallery ---- */
  document.addEventListener('click', function (ev) {
    var t = ev.target.closest('[data-thumb]');
    if (!t) return;
    var main = document.querySelector('[data-main-image]');
    if (main) { main.style.opacity = '0'; setTimeout(function () { main.src = t.getAttribute('data-full'); main.style.opacity = '1'; }, 130); }
    document.querySelectorAll('[data-thumb]').forEach(function (b) { b.classList.remove('is-on'); });
    t.classList.add('is-on');
  });

  /* ---- accordions ---- */
  document.addEventListener('click', function (ev) {
    var b = ev.target.closest('.acc__btn');
    if (!b) return;
    var item = b.parentElement, body = item.querySelector('.acc__body');
    var open = item.classList.toggle('is-open');
    body.style.maxHeight = open ? body.scrollHeight + 'px' : '0px';
  });

  /* ---- variant picker ---- */
  var form = document.querySelector('[data-variant-form]');
  if (form) {
    var selects = form.querySelectorAll('[data-opt]');
    var idField = form.querySelector('[name="id"]');
    var priceEl = document.querySelector('[data-price]');
    var btn = form.querySelector('[data-add]');
    var variants = [];
    try { variants = JSON.parse(document.getElementById('vx-variants').textContent); } catch (e) {}
    function sync() {
      var chosen = Array.prototype.map.call(selects, function (s) { return s.value; });
      var match = variants.filter(function (v) {
        return chosen.every(function (c, i) { return v.options[i] === c; });
      })[0];
      if (!match) return;
      idField.value = match.id;
      if (priceEl) priceEl.innerHTML = match.price_html;
      if (btn) {
        btn.disabled = !match.available;
        btn.textContent = match.available ? 'Add to bag' : 'Sold out';
      }
    }
    Array.prototype.forEach.call(selects, function (s) { s.addEventListener('change', sync); });
    sync();
  }
})();
